export default __webpack_public_path__ + "static/media/chat-bubble-white-off.a002470a.svg";